<template>
  <div
    id="seasidetms_row_ijc0xt5bz"
    class="seasidetms_row seasidetms_color_scheme_default seasidetms_row_top_default seasidetms_row_bot_default seasidetms_row_boxed"
  >
    <div class="seasidetms_row_outer_parent mt-20">
      <div class="seasidetms_row_outer">
        <div class="seasidetms_row_inner">
          <div class="seasidetms_row_margin seasidetms_131313">
            <div class="h3 edgtf-st-title text-center">
              <span style="color: #29292a">{{
                $t('importantBlock.header')
              }}</span>
            </div>
            <div
              id="seasidetms_column_yngxtu5zx7"
              class="seasidetms_column one_third"
            >
              <div class="seasidetms_column_inner">
                <div
                  id="seasidetms_icon_box_rpxurrztwc"
                  class="seasidetms_icon_box seasidetms_icon_top box_icon_type_icon seasidetms-icon-desktop-4 shortcode_animated"
                >
                  <div class="icon_box_inner">
                    <img src="/img/swim.svg" alt="" />
                    <div class="h3 icon_box_heading text-center">
                      {{ $t('importantBlock.1.header') }}
                    </div>
                    <div class="icon_box_text">
                      <p style="text-align: center">
                        {{ $t('importantBlock.1.text') }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="seasidetms_column_wpi9qlj075"
              class="seasidetms_column one_third"
            >
              <div class="seasidetms_column_inner">
                <div
                  id="seasidetms_icon_box_8rqqz25lz"
                  class="seasidetms_icon_box seasidetms_icon_top box_icon_type_icon seasidetms-icon-user-group shortcode_animated"
                >
                  <div class="icon_box_inner">
                    <img src="/img/vip-card.svg" alt="" />
                    <div class="h3 icon_box_heading text-center">
                      {{ $t('importantBlock.2.header') }}
                    </div>
                    <div class="icon_box_text">
                      <p style="text-align: center">
                        {{ $t('importantBlock.2.text') }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="seasidetms_column_dal5pypx5c"
              class="seasidetms_column one_third"
            >
              <div class="seasidetms_column_inner">
                <div
                  id="seasidetms_icon_box_a47q36163x"
                  class="seasidetms_icon_box seasidetms_icon_top box_icon_type_icon seasidetms-icon-phone-4 shortcode_animated"
                >
                  <div class="icon_box_inner">
                    <img src="/img/steal.svg" alt="" />
                    <div class="h3 icon_box_heading text-center">
                      {{ $t('importantBlock.3.header') }}
                    </div>
                    <div class="icon_box_text">
                      <p style="text-align: center">
                        {{ $t('importantBlock.3.text') }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="seasidetms_column_wpi9qlj075"
              class="seasidetms_column one_half"
            >
              <div class="seasidetms_column_inner">
                <div
                  id="seasidetms_icon_box_8rqqz25lz"
                  class="seasidetms_icon_box seasidetms_icon_top box_icon_type_icon seasidetms-icon-user-group shortcode_animated"
                >
                  <div class="icon_box_inner">
                    <img src="/img/bill.svg" alt="" />
                    <div class="h3 icon_box_heading text-center">
                      {{ $t('importantBlock.4.header') }}
                    </div>
                    <div class="icon_box_text">
                      <p style="text-align: center">
                        {{ $t('importantBlock.4.text') }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="seasidetms_column_wpi9qlj075"
              class="seasidetms_column one_half"
            >
              <div class="seasidetms_column_inner">
                <div
                  id="seasidetms_icon_box_8rqqz25lz"
                  class="seasidetms_icon_box seasidetms_icon_top box_icon_type_icon seasidetms-icon-user-group shortcode_animated"
                >
                  <div class="icon_box_inner">
                    <img src="/img/winner.svg" alt="" />
                    <div class="h3 icon_box_heading text-center">
                      {{ $t('importantBlock.5.header') }}
                    </div>
                    <div class="icon_box_text">
                      <p style="text-align: center">
                        {{ $t('importantBlock.5.text') }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style>
#seasidetms_row_ijc0xt5bz {
  margin-top: 20px;
}
.icon_box_inner img {
  width: 20%;
}
</style>
